import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { useApplicationSettings } from 'hooks/usePageConfig'
import {
  generateIncludedEmojisStrategy,
  generateIncludedProductHierarchyStrategy,
  generateIncludedSentimentDriverStrategy,
  generateIncludedTermsStrategy,
  generateSentimentsWithTermsStrategy
} from 'utils/insightModal/strategy/widgetSettingComposing'

const useWidgetSettingComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const applicationSettings = useApplicationSettings()
  const widgetSettingComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.EMOJIS_GROUP:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_EMOJI:
        return generateIncludedEmojisStrategy()

      case InsightViewOption.PRODUCT_NAME:
        return generateIncludedProductHierarchyStrategy(applicationSettings)

      case InsightViewOption.BRANDS:
      case InsightViewOption.HASHTAGS:
      case InsightViewOption.PEOPLE:
      case InsightViewOption.TERMS:
        return generateIncludedTermsStrategy(applicationSettings)

      case InsightViewOption.THINGS:
        return generateSentimentsWithTermsStrategy(applicationSettings)

      case InsightViewOption.ATTRIBUTES:
      case InsightViewOption.EMOTIONS:
      case InsightViewOption.BEHAVIORS:
        return generateIncludedSentimentDriverStrategy(applicationSettings)

      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption, applicationSettings])

  return widgetSettingComposingStrategy
}

export default useWidgetSettingComposingStrategy
